import { configureStore } from '@reduxjs/toolkit';
import reducer from './reducer';

const logger = (storeAPI) => (next) => (action) => {
    const prevState = storeAPI.getState(); // Get previous state
    const result = next(action); // Dispatch action
    const nextState = storeAPI.getState(); // Get next state

    console.log(
        `%cPrevious State: %o\n\n%cAction Dispatched: %o\n\n%cNext State: %o`,
        "color: gray; font-weight: bold;", prevState,
        "color: white; font-weight: bold;", action,
        "color: green; font-weight: bold;", nextState
    );

    return result;
}


export const store = configureStore({
    reducer,    
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(logger) 
});

export default store;
